// extracted by mini-css-extract-plugin
export default {"root":"ReviewDetailsHeader-module-root-Xttu8","title":"ReviewDetailsHeader-module-title-eBBij","buttons":"ReviewDetailsHeader-module-buttons-w0NKk"};